// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n\n.custom-width{\n    width:27em;\n}\n/* Competitions table end */\n", "",{"version":3,"sources":["webpack://./source/components/Competitions/Competitions.css"],"names":[],"mappings":";;AAEA;IACI,UAAU;AACd;AACA,2BAA2B","sourcesContent":["\n\n.custom-width{\n    width:27em;\n}\n/* Competitions table end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
